import _toConsumableArray from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { getOperationArgumentValueFromParameter } from "./operationHelpers.js";
import { getPathStringFromParameter } from "./interfaceHelpers.js";
var CollectionFormatToDelimiterMap = {
  CSV: ",",
  SSV: " ",
  Multi: "Multi",
  TSV: "\t",
  Pipes: "|"
};
export function getRequestUrl(baseUri, operationSpec, operationArguments, fallbackObject) {
  var urlReplacements = calculateUrlReplacements(operationSpec, operationArguments, fallbackObject);
  var isAbsolutePath = false;
  var requestUrl = replaceAll(baseUri, urlReplacements);

  if (operationSpec.path) {
    var path = replaceAll(operationSpec.path, urlReplacements); // QUIRK: sometimes we get a path component like /{nextLink}
    // which may be a fully formed URL with a leading /. In that case, we should
    // remove the leading /

    if (operationSpec.path === "/{nextLink}" && path.startsWith("/")) {
      path = path.substring(1);
    } // QUIRK: sometimes we get a path component like {nextLink}
    // which may be a fully formed URL. In that case, we should
    // ignore the baseUri.


    if (isAbsoluteUrl(path)) {
      requestUrl = path;
      isAbsolutePath = true;
    } else {
      requestUrl = appendPath(requestUrl, path);
    }
  }

  var _calculateQueryParame = calculateQueryParameters(operationSpec, operationArguments, fallbackObject),
      queryParams = _calculateQueryParame.queryParams,
      sequenceParams = _calculateQueryParame.sequenceParams;
  /**
   * Notice that this call sets the `noOverwrite` parameter to true if the `requestUrl`
   * is an absolute path. This ensures that existing query parameter values in `requestUrl`
   * do not get overwritten. On the other hand when `requestUrl` is not absolute path, it
   * is still being built so there is nothing to overwrite.
   */


  requestUrl = appendQueryParams(requestUrl, queryParams, sequenceParams, isAbsolutePath);
  return requestUrl;
}

function replaceAll(input, replacements) {
  var result = input;

  var _iterator = _createForOfIteratorHelper(replacements),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          searchValue = _step$value[0],
          replaceValue = _step$value[1];

      result = result.split(searchValue).join(replaceValue);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
}

function calculateUrlReplacements(operationSpec, operationArguments, fallbackObject) {
  var _a;

  var result = new Map();

  if ((_a = operationSpec.urlParameters) === null || _a === void 0 ? void 0 : _a.length) {
    var _iterator2 = _createForOfIteratorHelper(operationSpec.urlParameters),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var urlParameter = _step2.value;
        var urlParameterValue = getOperationArgumentValueFromParameter(operationArguments, urlParameter, fallbackObject);
        var parameterPathString = getPathStringFromParameter(urlParameter);
        urlParameterValue = operationSpec.serializer.serialize(urlParameter.mapper, urlParameterValue, parameterPathString);

        if (!urlParameter.skipEncoding) {
          urlParameterValue = encodeURIComponent(urlParameterValue);
        }

        result.set("{".concat(urlParameter.mapper.serializedName || parameterPathString, "}"), urlParameterValue);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return result;
}

function isAbsoluteUrl(url) {
  return url.includes("://");
}

function appendPath(url, pathToAppend) {
  if (!pathToAppend) {
    return url;
  }

  var parsedUrl = new URL(url);
  var newPath = parsedUrl.pathname;

  if (!newPath.endsWith("/")) {
    newPath = "".concat(newPath, "/");
  }

  if (pathToAppend.startsWith("/")) {
    pathToAppend = pathToAppend.substring(1);
  }

  var searchStart = pathToAppend.indexOf("?");

  if (searchStart !== -1) {
    var path = pathToAppend.substring(0, searchStart);
    var search = pathToAppend.substring(searchStart + 1);
    newPath = newPath + path;

    if (search) {
      parsedUrl.search = parsedUrl.search ? "".concat(parsedUrl.search, "&").concat(search) : search;
    }
  } else {
    newPath = newPath + pathToAppend;
  }

  parsedUrl.pathname = newPath;
  return parsedUrl.toString();
}

function calculateQueryParameters(operationSpec, operationArguments, fallbackObject) {
  var _a;

  var result = new Map();
  var sequenceParams = new Set();

  if ((_a = operationSpec.queryParameters) === null || _a === void 0 ? void 0 : _a.length) {
    var _iterator3 = _createForOfIteratorHelper(operationSpec.queryParameters),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var queryParameter = _step3.value;

        if (queryParameter.mapper.type.name === "Sequence" && queryParameter.mapper.serializedName) {
          sequenceParams.add(queryParameter.mapper.serializedName);
        }

        var queryParameterValue = getOperationArgumentValueFromParameter(operationArguments, queryParameter, fallbackObject);

        if (queryParameterValue !== undefined && queryParameterValue !== null || queryParameter.mapper.required) {
          queryParameterValue = operationSpec.serializer.serialize(queryParameter.mapper, queryParameterValue, getPathStringFromParameter(queryParameter));
          var delimiter = queryParameter.collectionFormat ? CollectionFormatToDelimiterMap[queryParameter.collectionFormat] : "";

          if (Array.isArray(queryParameterValue)) {
            // replace null and undefined
            queryParameterValue = queryParameterValue.map(function (item) {
              if (item === null || item === undefined) {
                return "";
              }

              return item;
            });
          }

          if (queryParameter.collectionFormat === "Multi" && queryParameterValue.length === 0) {
            continue;
          } else if (Array.isArray(queryParameterValue) && (queryParameter.collectionFormat === "SSV" || queryParameter.collectionFormat === "TSV")) {
            queryParameterValue = queryParameterValue.join(delimiter);
          }

          if (!queryParameter.skipEncoding) {
            if (Array.isArray(queryParameterValue)) {
              queryParameterValue = queryParameterValue.map(function (item) {
                return encodeURIComponent(item);
              });
            } else {
              queryParameterValue = encodeURIComponent(queryParameterValue);
            }
          } // Join pipes and CSV *after* encoding, or the server will be upset.


          if (Array.isArray(queryParameterValue) && (queryParameter.collectionFormat === "CSV" || queryParameter.collectionFormat === "Pipes")) {
            queryParameterValue = queryParameterValue.join(delimiter);
          }

          result.set(queryParameter.mapper.serializedName || getPathStringFromParameter(queryParameter), queryParameterValue);
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return {
    queryParams: result,
    sequenceParams: sequenceParams
  };
}

function simpleParseQueryParams(queryString) {
  var result = new Map();

  if (!queryString || queryString[0] !== "?") {
    return result;
  } // remove the leading ?


  queryString = queryString.slice(1);
  var pairs = queryString.split("&");

  var _iterator4 = _createForOfIteratorHelper(pairs),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var pair = _step4.value;

      var _pair$split = pair.split("=", 2),
          _pair$split2 = _slicedToArray(_pair$split, 2),
          name = _pair$split2[0],
          value = _pair$split2[1];

      var existingValue = result.get(name);

      if (existingValue) {
        if (Array.isArray(existingValue)) {
          existingValue.push(value);
        } else {
          result.set(name, [existingValue, value]);
        }
      } else {
        result.set(name, value);
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return result;
}
/** @internal */


export function appendQueryParams(url, queryParams, sequenceParams) {
  var noOverwrite = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (queryParams.size === 0) {
    return url;
  }

  var parsedUrl = new URL(url); // QUIRK: parsedUrl.searchParams will have their name/value pairs decoded, which
  // can change their meaning to the server, such as in the case of a SAS signature.
  // To avoid accidentally un-encoding a query param, we parse the key/values ourselves

  var combinedParams = simpleParseQueryParams(parsedUrl.search);

  var _iterator5 = _createForOfIteratorHelper(queryParams),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _step5$value = _slicedToArray(_step5.value, 2),
          name = _step5$value[0],
          value = _step5$value[1];

      var existingValue = combinedParams.get(name);

      if (Array.isArray(existingValue)) {
        if (Array.isArray(value)) {
          existingValue.push.apply(existingValue, _toConsumableArray(value));
          var valueSet = new Set(existingValue);
          combinedParams.set(name, Array.from(valueSet));
        } else {
          existingValue.push(value);
        }
      } else if (existingValue) {
        if (Array.isArray(value)) {
          value.unshift(existingValue);
        } else if (sequenceParams.has(name)) {
          combinedParams.set(name, [existingValue, value]);
        }

        if (!noOverwrite) {
          combinedParams.set(name, value);
        }
      } else {
        combinedParams.set(name, value);
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  var searchPieces = [];

  var _iterator6 = _createForOfIteratorHelper(combinedParams),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var _step6$value = _slicedToArray(_step6.value, 2),
          _name = _step6$value[0],
          _value = _step6$value[1];

      if (typeof _value === "string") {
        searchPieces.push("".concat(_name, "=").concat(_value));
      } else if (Array.isArray(_value)) {
        // QUIRK: If we get an array of values, include multiple key/value pairs
        var _iterator7 = _createForOfIteratorHelper(_value),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var subValue = _step7.value;
            searchPieces.push("".concat(_name, "=").concat(subValue));
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      } else {
        searchPieces.push("".concat(_name, "=").concat(_value));
      }
    } // QUIRK: we have to set search manually as searchParams will encode comma when it shouldn't.

  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  parsedUrl.search = searchPieces.length ? "?".concat(searchPieces.join("&")) : "";
  return parsedUrl.toString();
}